import { defineComponent as _defineComponent } from 'vue'
import { ref, useContext, watch } from "@nuxtjs/composition-api";
import { isValidEmail } from '~/core/validators/email';
import { ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";
import AuthService from "~/core/services/api-interaction/AuthService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const recoverPasswordForm = ref({
    email: '',
});
const emailError = ref('');
const isSubmitted = ref(false);
const isFormLoading = ref(false);
const recoverPasswordMailSent = ref(false);
const isFormValid = ref(false);
const context = useContext();

const resetPassword = async () => {
    isSubmitted.value = true;
    handleValidate();

    if (isFormValid.value) {
        try {
            isFormLoading.value = true;
            recoverPasswordMailSent.value = false;
            await AuthService.recoverPassword(recoverPasswordForm.value.email);
            recoverPasswordMailSent.value = true;
        } catch (error) {
            console.log(error);
            recoverPasswordMailSent.value = false;
            await context.store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_ERROR_TOAST}`, {
                description: context.i18n.t('Something went wrong, please refresh the page and try again'),
            })
        }
    }
}

const handleValidate = () => {
    emailError.value = '';
    isFormValid.value = true;

    const email = recoverPasswordForm.value.email;

    if (!email) {
        emailError.value = 'please_enter_your_email_address';
        isFormValid.value = false;
        return;
    }

    if (!isValidEmail(email)) {
        emailError.value = 'please_enter_a_valid_email_address';
        isFormValid.value = false;
        return;
    }
};

watch(
    () => recoverPasswordForm,
    () => {
        handleValidate();
    },
    { deep: true }
);

return { __sfc: true,recoverPasswordForm, emailError, isSubmitted, isFormLoading, recoverPasswordMailSent, isFormValid, context, resetPassword, handleValidate }
}

})